var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 3C3.52233 3 3 3.52233 3 4.16667V15.8333C3 16.4125 3.42198 16.893 3.97524 16.9844L12.9798 7.97982C13.175 7.78456 13.4916 7.78456 13.6869 7.97982L17 11.2929V4.16667C17 3.52233 16.4777 3 15.8333 3H4.16667ZM4.17311 18L4.15903 18C2.96593 17.9959 2 17.0274 2 15.8333V4.16667C2 2.97005 2.97005 2 4.16667 2H15.8333C17.03 2 18 2.97005 18 4.16667V12.4977V12.5023V15.8333C18 17.03 17.03 18 15.8333 18H4.17311ZM17 15.8333V12.7071L13.3333 9.04048L5.37382 17H15.8333C16.4777 17 17 16.4777 17 15.8333ZM6.33333 7.08337C6.33333 6.66916 6.66911 6.33337 7.08333 6.33337C7.49754 6.33337 7.83333 6.66916 7.83333 7.08337C7.83333 7.49759 7.49754 7.83337 7.08333 7.83337C6.66911 7.83337 6.33333 7.49759 6.33333 7.08337ZM7.08333 5.33337C6.11683 5.33337 5.33333 6.11688 5.33333 7.08337C5.33333 8.04987 6.11683 8.83337 7.08333 8.83337C8.04983 8.83337 8.83333 8.04987 8.83333 7.08337C8.83333 6.11688 8.04983 5.33337 7.08333 5.33337Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.afa9e557b65b65d73114dd027a854781.svg";
export { ForwardRef as ReactComponent };